import { render, staticRenderFns } from "./PrinterStatsCard.vue?vue&type=template&id=00210546&scoped=true&"
import script from "./PrinterStatsCard.vue?vue&type=script&lang=ts&"
export * from "./PrinterStatsCard.vue?vue&type=script&lang=ts&"
import style0 from "./PrinterStatsCard.vue?vue&type=style&index=0&id=00210546&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00210546",
  null
  
)

export default component.exports